const APIS = {
    AUTO_SUGGEST: window['runTimeData'].BASE_URL + 'auto_suggest/',
    TABLE_DATA: window['runTimeData'].BASE_URL + 'search/',
    HEIRARCHY_LIST: window['runTimeData'].BASE_URL + 'industry_subindustry_hierchical',
    GET_SECTOR: window['runTimeData'].BASE_URL + 'unique/sector/',
    GET_INVESTOR: window['runTimeData'].BASE_URL + 'unique/investor/',
    LOGIN_USER: window['runTimeData'].BASE_URL + 'token/obtain/',
    GET_USERID: window['runTimeData'].BASE_URL + 'user/getuserid/',
    CHANGE_PASSWORD: window['runTimeData'].BASE_URL + 'user/changepassword/',
    LOGOUT_USER: window['runTimeData'].BASE_URL + 'blacklist/',
    REGISTER_USER: window['runTimeData'].BASE_URL + 'user/create/',
    GLOBAL_SEARCH: window['runTimeData'].BASE_URL + 'search/global/',
    TEST_API: window['runTimeData'].BASE_URL + 'hello/',
    GET_ENTITY_POPUP_DATA: window['runTimeData'].BASE_URL + 'get_popup_data/',
    PROFILE: window['runTimeData'].BASE_URL + 'profile/',
    DOWNLOAD_EXCEL: window['runTimeData'].BASE_URL + 'download_csv/',
    FETCH_NEWS: window['runTimeData'].BASE_URL + 'fetch-news',
    FETCH_SIGNAL: window['runTimeData'].BASE_URL + 'fetch-signal',
    GET_STACK_VIEW: window['runTimeData'].BASE_URL + 'stack/getStackData?sector=',
    COMPANY_PROFILE: window['runTimeData'].BASE_URL + 'company-profile/',
    GET_COMPARABLES: window['runTimeData'].BASE_URL + 'company-profile/getComparables?Permalink=',
    UPDATE_STACK_PROCESSING: 'https://dev.bostonanalytics.com/industryMapping/updateStackVisualization'

    //SORT_TABLE_DATA: BASE_URL + 'search/company/sort/colname/orderbykey/offset/'
}

export {
    APIS
}
